import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

const CLIENTS_KEY = KEYS.client.clients.list();

function useGetClients() {
  const { showApiError } = useGlobalContext();
  const { client: clientApi } = useApiContext();
  const { t } = useTranslation('global');

  const { data: clients, isLoading: isClientsLoading } = useQuery(
    CLIENTS_KEY,
    () => clientApi.clients.list(),
    {
      select: (data) =>
        data?.data?.data?.map((value) => ({
          label: value.name,
          id: `${value.id}`,
          projectName: value.projectName
        })),
      onError: (error) =>
        showApiError(error, t('common.commonMessages.genericRequestError')),
      refetchOnWindowFocus: false
    }
  );

  return {
    clients: clients || [],
    isClientsLoading
  };
}

export default useGetClients;
